import React, {useEffect} from "react";
import {useMutationHooks} from "../../hooks/useMutationHook";
import * as ProjectService from "../../services/ProjectService";
import {useState} from "react";
import {toast} from "react-toastify";
import Toast from "../Toast/Toast";
import {useSelector} from "react-redux";

function AddProject() {
    const [project, setProject] = useState("");
    const toastId = React.useRef(null);
    const userLogin = useSelector((state) => state.user);
    const {access_token} = userLogin;
    const Toastobjects = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    };
    const mutationAddProject = useMutationHooks((data) => {
        const res = ProjectService.createdProject(access_token, data);
        return res;
    });
    const submitHandler = async (event) => {
        event.preventDefault();
        const data = {
            project: project,
        };
        await mutationAddProject.mutate(data);
    };
    const {error, isLoading, isSuccess, isError} = mutationAddProject;
    useEffect(() => {
        if (!error && isSuccess) {
            if (!toast.isActive(toastId.current)) {
                toastId.current = toast.success(
                    "Thêm mới dự án thành công",
                    Toastobjects
                );
            }
        } else if (error) {
            if (!toast.isActive(toastId.current)) {
                toastId.current = toast.error(
                    error.response.data.message,
                    Toastobjects
                );
            }
        }
    }, [error, isSuccess]);
    return (
        <>
            <Toast/>
            <div
                className="w-full max-w-5xl mx-auto p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
                <form className="space-y-6" action="#">
                    <h5 className="text-xl font-medium text-gray-900 dark:text-white">
                        Thêm dự án
                    </h5>
                    <div className="md:flex md:justify-center md:gap-2">
                        <div className="mb-5">
                            <label
                                htmlFor="project"
                                className="block mb-2 text-sm font-medium text-start text-gray-900"
                            >
                                Dự án <span className="text-red-600">(*)</span>
                            </label>
                            <input
                                type="text"
                                id="project"
                                onChange={(e) => setProject(e.target.value)}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder="Dự án"
                                required
                            />
                        </div>
                    </div>
                    <button
                        onClick={submitHandler}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                    >
                        Thêm dự án
                    </button>
                </form>
            </div>
        </>
    );
}

export default AddProject;
